import React, { useState } from 'react'
import './DeletePopUp.sass'
import PopUp from '../PopUp'
import Icon from '../../Icon/Icon'
import Button from '../../Button/Button'

export default function DeletePopUp({
  title,
  warningMessage,
  closePopUp,
  submitDelete,
  submitTitle = 'Видалити',
  submitFill = 'noty',
  cancelTitle = 'Закрити',
}) {
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = () => {
    setIsLoading(true)
    Promise.resolve(submitDelete())
      .then(() => closePopUp())
      .catch(() => setIsLoading(false))
  }

  return (
    <PopUp
      title={title}
      customButtons={[
        <Button
          key="submit"
          isLoading={isLoading}
          onClick={onSubmit}
          title={submitTitle}
          theme="solid"
          fill={submitFill}
        />,
        <Button
          key="cancel"
          onClick={closePopUp}
          title={cancelTitle}
          theme="bounded"
          border="gray"
          color="gray"
        />,
      ]}
      show
      close={closePopUp}
    >
      <div className="DeletePopUp-WarningMessage">
        <Icon name="exclamation-triangle" className="DeletePopUp-WarningIcon" />
        <p>{warningMessage}</p>
      </div>
    </PopUp>
  )
}
